module.exports = __webpack_public_path__ + "images/top-sichuan.png?eb27be616d98d8ee15ccda1129cf3da9";


//////////////////
// WEBPACK FOOTER
// ./src/images/active/top-sichuan.png
// module id = 201
// module chunks = 1